module.exports = __webpack_public_path__ + "pin-tuan/static/media/banner.c0bf2d93.png";